// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"1462bdd3f87be80bb8a7","218":"3905fb51c89a52911b2b","491":"104e0f7945d04eabdc09","691":"b1fa0aa24f5394a53d25","774":"51606ce199e9e4bb31e4","932":"01432bc2e800f1969bf3"}[chunkId] + ".js";
};